import { render, staticRenderFns } from "./_panelGroup.vue?vue&type=template&id=432e5338&scoped=true"
import script from "./_panelGroup.vue?vue&type=script&lang=js"
export * from "./_panelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e5338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432e5338')) {
      api.createRecord('432e5338', component.options)
    } else {
      api.reload('432e5338', component.options)
    }
    module.hot.accept("./_panelGroup.vue?vue&type=template&id=432e5338&scoped=true", function () {
      api.rerender('432e5338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/_panelGroup.vue"
export default component.exports